import TestEditor from '@/components/TestEditor';
import { memo } from 'react';
import BoldText from '../BoldText';
import Required from '../Required';
import CustomCard from '../customCard';
import VariableTooltips from './VariableTooltips';

interface IProps {
  value: string;
  onchange: (value: string, styled_value?: string) => void;
  isRequired?: boolean;
  disableCardBorder?: boolean;
  isBlueTitle?: boolean;
  defaultError?: string;
}

const EstimatedTextCard = (props: IProps) => {
  const content = (
    <>
      <div className="mb-16 mt-8">
        <VariableTooltips />
      </div>
      <TestEditor
        isRequired={props.isRequired}
        value={props.value || ''}
        onBlur={props.onchange}
        defaultError={props.defaultError}
      />
    </>
  );
  return (
    <div className="mt-8">
      {props.disableCardBorder ? (
        <>
          <BoldText>Message text {props.isRequired ? <Required /> : null}</BoldText>
          {content}
        </>
      ) : (
        <CustomCard
          textClassName={props.isBlueTitle ? 'text--blue bold-text-styled' : ''}
          required={props.isRequired}
          hasDroplist
          title={'Message text'}
        >
          {content}
        </CustomCard>
      )}
    </div>
  );
};

export default memo(EstimatedTextCard);
